import { EcomicService } from './../../service/comics/ecomic.service';
import { Season } from './../../models';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-e-comic-seasons',
  templateUrl: './e-comic-seasons.component.html',
  styleUrls: ['./e-comic-seasons.component.css']
})
export class EComicSeasonsComponent implements OnInit {
  Ecomicseasoncol: AngularFirestoreCollection<Season>;
  Ecomicseason: Observable<Season[]>;
  status: any = 'All';
  series: any = 'All';
  seriesdata: any;
  showseries: any = false;
  id:any;
  constructor(private afs: AngularFirestore, private ecomicService: EcomicService) { }

  async ngOnInit() {
    const seriesdata = await this.ecomicService.getserious();
    seriesdata.subscribe(data => {
      this.seriesdata = data;
      this.showseries = true;
    });
    this.filterseasons();
  }
  filterseasons() {
    const key = this.status != 'All' ? 'status' : 'comic_series';
    const value = this.status != 'All' ? this.status : this.series ;
    this.Ecomicseasoncol = this.afs.collection('Ecomicseason', res => {
    if (this.status == 'All' && this.series == 'All') {
      return res.orderBy('createdAt', 'desc');
    } else {
      return res.orderBy('createdAt', 'desc').where(key, '==', value);
    }
    });
    this.Ecomicseason = this.Ecomicseasoncol.valueChanges();
  }
  delete(id) {
    console.log(id);
    this.id = id;
    $("#DeleteModal").modal();
  }
  deletedata() {
    $('#DeleteModal').modal('hide');
    this.ecomicService.deleteseries('Ecomicepisode','comic_seasons',this.id).then(status =>{
      if(status){
        this.afs.doc('/Ecomicseason/'+this.id).delete().then(function () {  
          swal('Deleted!', 'Your List has been deleted.', 'success');
        }).catch(function(error){
          swal('Error!', error, 'error');
          console.error("error in removing document:",error);
        });
      } else {
        swal('Error!', 'Your are not permitted to delete.', 'error');
        console.log('not permited');
        
      }
    })
     
  }

}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-seasons/e-comic-seasons.component.ts